import { FC, SyntheticEvent, useState } from "react";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { useTranslation } from "react-i18next";
import { View } from "../../components/layout/View";
import PaperCard from "../../components/widgets/PaperCard";
import { PageType } from "../../config/page.types";
import CompanyDetails from "./components/company/";
import RolesList from "./components/roles/RolesList";
import UsersList from "./components/users/UsersList";

enum tabIndex {
	Users,
	Roles,
	Company,
}

const SettingsAdmin = () => {
	const { t } = useTranslation();
	const [tabValue, setTabValue] = useState<tabIndex>(tabIndex.Company);

	const handleTabChange = (event: SyntheticEvent, newValue: tabIndex) => {
		setTabValue(newValue);
	};

	return (
		<View pageType={PageType.SettingsAdmin} sx={{ maxWidth: "100vw", overflowX: "hidden" }}>
			<TabContext value={tabValue}>
				<Box sx={{ borderBottom: 1, borderColor: "divider", pb: 3 }}>
					<TabList onChange={handleTabChange} aria-label="placeholder tabs">
						<Tab label={t("users")} value={tabIndex.Users} />
						<Tab label={t("roles")} value={tabIndex.Roles} />
						<Tab label={t("company")} value={tabIndex.Company} />
					</TabList>
				</Box>
				<TabPanel sx={{ p: 0, m: 0 }} value={tabIndex.Users}>
					<PaperCard sxContent={{ p: 0 }} content={<UsersList />}></PaperCard>
				</TabPanel>
				<TabPanel sx={{ p: 0, m: 0 }} value={tabIndex.Roles}>
					<PaperCard sxContent={{ p: 0 }} content={<RolesList />}></PaperCard>
				</TabPanel>
				<TabPanel sx={{ p: 0, m: 0 }} value={tabIndex.Company}>
					<PaperCard sxContent={{ px: 2, pb: 2, m: 0 }} content={<CompanyDetails id={1} />}></PaperCard>
				</TabPanel>
			</TabContext>
		</View>
	);
};

export default SettingsAdmin;
